import { Moment } from './date_helpers';
import jwtDecode from 'jwt-decode';
import { openNotification } from '../../commons/Notifications';

export const checkTokenExpired = () => {

  let tkn = localStorage.getItem('token');
  if (tkn) {
    let decoded: any = jwtDecode(tkn);
    const expDate = Moment(decoded.exp, 'X');

    if (Moment() > expDate) {
      localStorage.removeItem('token');
      openNotification({
        message: 'Sessione Scaduta!',
        description: 'è necessario eseguire nuovamente il login',
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);

      return true;
    }
    return false;
  }
  return false;
};
